module.exports = __webpack_public_path__ + "static/media/dog-chasing-tail.50145e83.gif";